<ng-container *ngFor="let item of template; let i = index">
  <ng-container *ngIf="item.type === 'text'">{{ item.content }}</ng-container>
  <ng-container *ngIf="item.type === 'select'">
    <select class="template-select" [(ngModel)]="value[item.index]" placeholder="请选择" (ngModelChange)="selectChange($event, i)">
      <option *ngFor="let option of item.options; let j = index" [value]="option">{{ option }}</option>
    </select>
    <sup>[{{ item.index + 1 }}]</sup>
  </ng-container>
  <!-- input -->
  <ng-container *ngIf="item.type === 'input'">
    <input class="template-input" [(ngModel)]="value[item.index]" (ngModelChange)="selectChange($event, i)" />
    <sup>[{{ item.index + 1 }}]</sup>
  </ng-container>
  <ng-container *ngIf="item.type === 'reference'">{{ value[item.vIndex] }} </ng-container>
</ng-container>
<!-- empty -->
<ng-container *ngIf="template.length === 0">
  <div class="template-empty">无</div>
</ng-container>
